import React, { useState } from 'react';
import { mountOn } from './lib/mount';
import { TiptapEditor, TiptapToolbar } from './components/tiptap_editor';

const SAMPLE_CONTENT = {
  type: 'doc',
  content: [
    { type: 'heading', attrs: { level: 1 }, content: [{ type: 'text', text: 'Welcome to the Tiptap experiment' }] },
    { type: 'paragraph', content: [{ type: 'text', text: 'This is a test of the Tiptap editor with FlyTabs design tokens.' }] },
    { type: 'heading', attrs: { level: 2 }, content: [{ type: 'text', text: 'Features to test' }] },
    { type: 'taskList', content: [
      { type: 'taskItem', attrs: { checked: true }, content: [{ type: 'paragraph', content: [{ type: 'text', text: 'Headings (h1, h2, h3)' }] }] },
    ]},
    { type: 'taskList', content: [
      { type: 'taskItem', attrs: { checked: true }, content: [{ type: 'paragraph', content: [{ type: 'text', text: 'Paragraphs with text formatting' }] }] },
    ]},
    { type: 'taskList', content: [
      { type: 'taskItem', attrs: { checked: false }, content: [{ type: 'paragraph', content: [{ type: 'text', text: 'Checklist items' }] }] },
    ]},
    { type: 'taskList', content: [
      { type: 'taskItem', attrs: { checked: false }, content: [{ type: 'paragraph', content: [{ type: 'text', text: 'Callout / blockquote' }] }] },
    ]},
    { type: 'taskList', content: [
      { type: 'taskItem', attrs: { checked: false }, content: [{ type: 'paragraph', content: [{ type: 'text', text: 'Horizontal divider' }] }] },
    ]},
    { type: 'horizontalRule' },
    { type: 'heading', attrs: { level: 3 }, content: [{ type: 'text', text: 'Callout example' }] },
    { type: 'blockquote', attrs: { tone: 'note' }, content: [{ type: 'paragraph', content: [{ type: 'text', text: 'This is an informational callout block styled with the design system.' }] }] },
    { type: 'paragraph', content: [{ type: 'text', text: 'Try selecting text to see the toolbar. Use it to toggle bold, italic, underline, and change block types.' }] },
  ],
};

function TiptapTest() {
  const [doc, setDoc] = useState(SAMPLE_CONTENT);
  const [editor, setEditor] = useState(null);
  const [, setTick] = useState(0);
  const handleReady = (ed) => {
    setEditor(ed);
    ed.on('selectionUpdate', () => setTick(t => t + 1));
    ed.on('transaction', () => setTick(t => t + 1));
  };

  return (
    <div style={{ maxWidth: 720, margin: '40px auto', padding: '0 24px' }}>
      <div style={{ marginBottom: 16, fontFamily: 'var(--font-sans)', color: 'var(--text-secondary)', fontSize: 12, letterSpacing: '0.32px', textTransform: 'uppercase' }}>
        Tiptap Editor Experiment
      </div>
      <div style={{ border: '1px solid var(--border-subtle-01)', background: 'var(--white)' }}>
        <TiptapToolbar editor={editor} />
        <TiptapEditor content={doc} onChange={setDoc} onEditorReady={handleReady} />
      </div>
      <details style={{ marginTop: 24 }}>
        <summary style={{ fontFamily: 'var(--font-sans)', fontSize: 12, color: 'var(--text-secondary)', cursor: 'pointer' }}>
          JSON output
        </summary>
        <pre style={{ fontFamily: 'var(--font-mono)', fontSize: 11, background: 'var(--gray-10)', padding: 12, marginTop: 8, overflow: 'auto', maxHeight: 300 }}>
          {JSON.stringify(doc, null, 2)}
        </pre>
      </details>
    </div>
  );
}

mountOn('tiptap-test-root', <TiptapTest />);
